import { Grid, Typography, Container } from '@mui/material';
import Link from 'next/link';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import VectorIcon from 'ui-component/HeaderSectionIcon';

interface ServicesSectionProps {
  handlePopoverClose: () => void;
}

const ServicesSection = ({ handlePopoverClose }: ServicesSectionProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  const CustomLink = ({ link, text }: { link: string; text: string }) => (
    <Grid size={{ xs: 12 }}>
      <Grid
        container
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
          '&:hover .text': {
            color: theme.palette.mode === 'dark' ? '#ED731D' : '#135799'
          }
        }}
      >
        <Grid>
          <VectorIcon />
        </Grid>
        <Grid>
          <Typography
            variant="body2"
            className="text"
            sx={{
              lineHeight: 1.4,
              textAlign: 'start',
              color: theme.palette.mode === 'dark' ? 'white' : 'text.primary',
              marginLeft: 2,
              wordBreak: 'break-word'
            }}
          >
            <Link href={link} onClick={handlePopoverClose}>
              {formatMessage({ id: text })}
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Container sx={{ padding: 4 }}>
      <Grid container spacing={2}>
        <Grid
          size={{ md: 3 }}
          sx={{
            paddingRight: '16px',
            borderRight: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.dark.light + 15 : theme.palette.grey[300]}`
          }}
        >
          <Grid container spacing={2} pl={1}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { xs: 16, md: 20 },
                  fontWeight: 600,
                  lineHeight: 1.4,
                  textAlign: 'start',
                  color: theme.palette.mode === 'dark' ? 'white' : '#135799'
                }}
              >
                {formatMessage({ id: 'SERVICES.SECTION.HEADER.1' })}
              </Typography>
            </Grid>
            <CustomLink text="SOFTWARE.DEVELOPMENT" link="services" />
            <CustomLink text="INTEGRATION" link="services" />
            <CustomLink text="CLOUD.BASED.SOFTWARE.DEVELOPMENT" link="services" />
            <CustomLink text="MOBILE.SOFTWARE.DEVELOPMENT" link="services" />
          </Grid>
        </Grid>
        <Grid
          size={{ md: 3 }}
          sx={{
            paddingRight: '16px',
            borderRight: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.dark.light + 15 : theme.palette.grey[300]}`
          }}
        >
          <Grid container spacing={2} pl={1}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { xs: 16, md: 20 },
                  fontWeight: 600,
                  lineHeight: 1.4,
                  textAlign: 'start',
                  color: theme.palette.mode === 'dark' ? 'white' : '#135799'
                }}
              >
                {formatMessage({ id: 'SERVICES.SECTION.HEADER.2' })}
              </Typography>
            </Grid>
            <CustomLink text="INFRASTRUCTURE.MANAGEMENT" link="services" />
            <CustomLink text="BIG.DATA.AND.ANALYSTICS" link="services" />
            <CustomLink text="CLOUD.SOLUTIONS.CONSULTANCY" link="services" />
            <CustomLink text="QUALITY.MANAGEMENT" link="services" />
            <CustomLink text="BUSINESS.PROCESS.MANAGEMENT" link="services" />
          </Grid>
        </Grid>
        <Grid
          size={{ md: 3 }}
          sx={{
            paddingRight: '16px',
            borderRight: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.dark.light + 15 : theme.palette.grey[300]}`
          }}
        >
          <Grid container spacing={2} pl={1}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { xs: 16, md: 20 },
                  fontWeight: 600,
                  lineHeight: 1.4,
                  textAlign: 'start',
                  color: theme.palette.mode === 'dark' ? 'white' : '#135799'
                }}
              >
                {formatMessage({ id: 'SERVICES.SECTION.HEADER.3' })}
              </Typography>
            </Grid>
            <CustomLink text="OUTSOURCE.SERVICES" link="services" />
            <CustomLink text="IT.TEAM.SUPPORT" link="services" />
            <CustomLink text="PROJECT.MANAGEMENT.SERVICES" link="services" />
          </Grid>
        </Grid>
        <Grid
          size={{ md: 3 }}
          sx={{
            paddingRight: '16px',
            borderRight: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.dark.light + 15 : theme.palette.grey[300]}`
          }}
        >
          <Grid container spacing={2} pl={1}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { xs: 16, md: 20 },
                  fontWeight: 600,
                  lineHeight: 1.4,
                  textAlign: 'start',
                  color: theme.palette.mode === 'dark' ? 'white' : '#135799'
                }}
              >
                {formatMessage({ id: 'SERVICES.SECTION.HEADER.4' })}
              </Typography>
            </Grid>
            <CustomLink text="SOFTWARE.ARCHITECTURAL.SERVICES" link="services" />
            <CustomLink text="MACHINE.LEARNING.AND.AI" link="services" />
            <CustomLink text="DEVOPS.IMPLEMENTATION" link="services" />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ServicesSection;
